<template>
  <div class="role-setting">
    <el-dialog
      title="编辑角色"
      :visible.sync="visible"
      @open="open"
      :before-close="hideDialog"
      :modal="false"
      :fullscreen="true"
      custom-class="role-setting"
      append-to-body
    >
      <div v-if="!showForm" v-loading="!showForm" style="height: 60px"></div>
      <el-form v-else :model="form" label-width="120px">
        <el-form-item label="角色名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item label="工作表权限">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="工作表名称"
            clearable
            prefix-icon="el-icon-search"
            class="search"
          ></el-input>
          <el-collapse v-model="activeSheet" accordion>
            <el-collapse-item
              v-for="sheet in searchSheets"
              :key="sheet.id"
              :title="sheet.name"
              :name="sheet.sheetId"
            >
              <div class="sheet-wrap sheet-item">
                <div class="select-all">
                  <el-checkbox
                    :value="isAllChecked(privileges[sheet.sheetId])"
                    @change="changeSheetPrivilege($event, privileges[sheet.sheetId])"
                  >
                    <b>全部</b>
                  </el-checkbox>
                </div>
                <div class="permission-list">
                  <div v-for="def in basePris" :key="def.value" class="list-item">
                    <el-checkbox
                      :value="privileges[sheet.sheetId][def.value] != 'NONE'"
                      @change="changePrivilege($event, privileges[sheet.sheetId], def.value)"
                    >
                      <span :title="def.name">{{ def.name }}</span>
                    </el-checkbox>
                  </div>
                  <template v-if="sheet.btns.length > 0">
                    <div v-for="(btn, index) in sheet.btns" :key="index" class="list-item">
                      <el-checkbox
                        :value="privileges[sheet.sheetId][btn.id] != 'NONE'"
                        @change="changePrivilege($event, privileges[sheet.sheetId], btn.id)"
                      >
                        <span :title="btn.name">{{ btn.name }}</span>
                      </el-checkbox>
                    </div>
                  </template>
                </div>
              </div>
              <div class="right-wrap" v-if="privileges[sheet.sheetId].R != 'NONE'">
                <el-button type="text" @click="showFieldsSetting(privileges[sheet.sheetId])">
                  设置
                </el-button>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>
        <el-form-item label="看板权限">
          <el-collapse>
            <el-collapse-item title="看板" name="board">
              <div class="boards">
                <el-checkbox
                  :indeterminate="dashboardIndeterminate"
                  :value="dashboardCheckAll"
                  @input="handleCheckAllChange"
                  style="padding-left: 10px; flex-basis: 160px;"
                >
                  全部
                </el-checkbox>
                <el-checkbox-group v-model="form.dashboardList">
                  <el-checkbox v-for="board in boards" :label="board.id" :key="board.id">
                    {{ board.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="hideDialog">
          取消
        </el-button>
        <el-button type="primary" @click="submit">
          提交
        </el-button>
      </div>
    </el-dialog>
    <details-setting ref="detailsSettingDialog" @submit="getDetailsSetting"></details-setting>
  </div>
</template>

<script>
import { deepClone } from "@/utils/common"
import { basePrivileges, levelOptions } from "~/data/static"
import { sheetBtnApi } from "@/api/sheet/sheetBtn"
import DetailsSetting from "./details-setting"

export default {
  name: "role-setting",
  components: { DetailsSetting },
  inject: ["app"],
  data() {
    return {
      activeSheet: "",
      checked: false,
      showForm: false,
      appBtns: [],
      form: {},
      basePris: basePrivileges,
      levelOptions,
      privileges: {},
      searchText: ""
    }
  },
  props: {
    visible: Boolean,
    role: Object,
    sheets: Array,
    boards: Array
  },
  computed: {
    searchSheets() {
      return this.sheets.filter(sheet => sheet.name.includes(this.searchText))
    },
    currentSheet() {
      if (!this.sheets || this.sheets.length == 0 || !this.activeSheet) return {}
      return this.sheets.find(i => i.sheetId == this.activeSheet)
    },
    levelOptionsMap() {
      let levelOptionsMap = {}
      for (let item of this.levelOptions) {
        levelOptionsMap[item.name] = item.value
      }
      return levelOptionsMap
    },
    basePrisMap() {
      let basePrisMap = {}
      for (let item of this.basePris) {
        basePrisMap[item.value] = item.name
      }
      return basePrisMap
    },
    dashboardCheckAll() {
      return this.form.dashboardList?.length === this.boards.length
    },
    dashboardIndeterminate() {
      return (
        this.form.dashboardList?.length > 0 && this.form.dashboardList.length < this.boards.length
      )
    }
  },
  methods: {
    // 打开 dialog
    async open() {
      this.form = deepClone(this.role)
      await this.getAppBtns()
      this.initAllPris()
    },
    // 关闭 dialog
    hideDialog() {
      this.$emit("update:visible", false)
    },
    getAppBtns() {
      return sheetBtnApi.getAppBtns(this.app.id, true).then(btns => {
        this.appBtns = this._.chain(btns)
          .groupBy("sheetId")
          .mapValues(btnList => btnList.map(({ id, name }) => ({ id, name })))
          .value()
        this.sheets.forEach(item => {
          item.btns = this.appBtns[item.sheetId] || []
        })
      })
    },
    // 显示字段设置dialog
    showFieldsSetting(sheetPrivilege) {
      this.$refs.detailsSettingDialog.open({
        sheet: this.currentSheet,
        sheetPris: sheetPrivilege,
        fieldPrisMap: this.form.fieldPrisMap
      })
    },
    // 接收数据范围、字段权限设置结果
    getDetailsSetting(rangePris, fieldPris) {
      // 保存字段权限
      if (!this.form.fieldPrisMap) this.form.fieldPrisMap = {}
      Object.assign(this.form.fieldPrisMap, fieldPris)
      // 保存数据范围权限
      this.privileges[this.activeSheet] = rangePris
    },
    // 改变工作表的所有权限
    changeSheetPrivilege(checked, sheetPrivilege) {
      let level = checked ? this.levelOptionsMap["全部"] : "NONE"
      for (let key in sheetPrivilege) {
        sheetPrivilege[key] = level
      }
    },
    // 改变某个权限
    changePrivilege(checked, sheetPrivilege, type) {
      if (checked) {
        // 创建的权限默认是且只能是负责人才有的
        sheetPrivilege[type] =
          type == "C" ? this.levelOptionsMap["负责的"] : this.levelOptionsMap["全部"]
        // 勾选“查看”之外的权限，“查看”权限也被选中
        if (type != "R" && sheetPrivilege["R"] == "NONE") {
          sheetPrivilege["R"] = this.levelOptionsMap["全部"]
        }
      } else {
        sheetPrivilege[type] = "NONE"
        // 取消“查看”权限，其它权限也被取消
        if (type == "R") {
          for (let type in sheetPrivilege) {
            sheetPrivilege[type] = "NONE"
          }
        }
      }
    },
    isAllChecked(sheetPrivilege) {
      return !Object.keys(sheetPrivilege).some(type => sheetPrivilege[type] == "NONE")
    },
    initAllPris() {
      // 初始化所有工作表权限的默认值
      let privileges = this.getInitialPris()
      for (let item of this.form.privileges) {
        if (!privileges[item.sheetId]) continue
        privileges[item.sheetId][item.type || item.btnId] = item.level || "NONE"
      }
      this.privileges = privileges
      this.$nextTick(() => (this.showForm = true))
    },
    getInitialPris() {
      let privileges = {}
      for (let sheet of this.sheets) {
        // 设置基本权限的默认值
        let privilege = {}
        this.basePris.forEach(pri => (privilege[pri.value] = "NONE"))
        // 设置自定义按钮权限的默认值
        ;(this.appBtns[sheet.sheetId] || []).forEach(item => (privilege[item.id] = "NONE"))
        privileges[sheet.sheetId] = privilege
      }
      return privileges
    },
    // 将this.privileges恢复成初始结构
    resolvePrivileges() {
      let privileges = []
      for (let sheetId in this.privileges) {
        let sheetPrivilege = this.privileges[sheetId],
          list = []
        for (let type in sheetPrivilege) {
          if (sheetPrivilege[type] === "NONE") continue
          if (this.basePrisMap[type]) {
            list.push({ type, sheetId, level: sheetPrivilege[type] })
          } else {
            list.push({ btnId: type, sheetId, level: sheetPrivilege[type] })
          }
        }
        privileges = privileges.concat(list)
      }
      return privileges
    },
    // 保存
    submit() {
      this.form.privileges = this.resolvePrivileges()
      this.$emit("submit", this.form)
    },
    handleCheckAllChange(val) {
      this.form.dashboardList = val ? this.boards.map(board => board.id) : []
    }
  }
}
</script>

<style lang="scss" scoped>
.role-setting {
  margin-top: 20px;
  .search {
    margin-bottom: 10px;
  }
  .sheet-item {
    display: flex;
    // align-items: center;
    background: #eee;
    padding: 10px 0;
    &:not(:first-child) {
      border-top: 1px solid #fff;
    }
    .select-all {
      height: 24px;
      flex-basis: 160px;
      min-width: 160px;
      padding-left: 10px;
      box-sizing: border-box;
    }
    .permission-list {
      flex: auto;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .list-item {
        height: 24px;
        display: flex;
        align-items: center;
        flex-basis: 150px;
        &::first-line {
          margin-top: 20px;
        }
        ::v-deep .el-checkbox {
          display: flex;
          align-items: center;
        }
        ::v-deep .el-checkbox__label {
          max-width: 114px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .boards {
    display: flex;
    background: #eee;
    padding: 10px 0;
    width: 100%;
  }
  .el-collapse-item__content {
    position: relative;
  }
}
</style>

<style lang="scss">
.role-setting {
  .el-collapse .el-collapse-item__content {
    display: flex;
    padding-bottom: 0;
    .sheet-wrap {
      flex: 1 1;
    }
    .right-wrap {
      display: flex;
      flex-basis: 200px;
      justify-content: center;
      align-items: center;
      margin-left: 1px;
      background: #eee;
      border-left: 1px solid #fff;
    }
  }
}
</style>
